import { actionTypes as bringAssetsDialogActionsTypes } from '../../../actions/Dialogs/BringAssetsDialog/bringAssetsDialogActions.js';
import { Map, List } from 'immutable';

let defaultState = {
  show: false,
  assets : Map(),
  entitiesTypes: List(),
  boEntityFilter: '',
  cancelToken: '',
  loading: false,
};


export default function(state = Map(defaultState), action) {

  switch(action.type) {
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_FETCH_ASSETS_READY:
      return state.setIn(["assets", action.payload.assetType.toLowerCase()], action.payload.dataList );
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_SHOW:
      return state.set('currentAssets', action.payload)
        .set('boEntityFilter', action.payload && action.payload.boEntityFilter ? action.payload.boEntityFilter : '')
        .set('entitiesTypes', action.payload && action.payload.entitiesTypes ? List(action.payload.entitiesTypes) : '')
        .set("show", true);
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_HIDE:
      return Map(defaultState);
    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_SAVE_CANCEL_TOKEN:
      return state.set("cancelToken", action.payload);

    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_SET_VALIDATION_WARNINGS_DATA:
      return state.set('validationMessage', action.payload)
        .set('hasError', !!action.payload.errors)
        .set('showIgnoreValidationCheckbox', !action.payload.errors)
        .set('hasHighSeverityWarning', action.payload.reset ? false : action.payload.hasHighSeverityWarning)
        .set('hasMediumSeverityWarning', action.payload.reset ? false : action.payload.hasMediumSeverityWarning)
        .set('isIgnoreValidationWarnings', false);

    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('showIgnoreValidationCheckbox', false)
        .set('hasHighSeverityWarning', false)
        .set('hasMediumSeverityWarning', false)
        .set('hasError', false)
        .set('isIgnoreValidationWarnings', false);

    case bringAssetsDialogActionsTypes.BRINGASSETS_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('isIgnoreValidationWarnings', action.payload);

    default:
      return state;
  }
}


